import { takeEvery } from 'redux-saga'
import { call, put } from 'redux-saga/effects'
import fetcher from 'modules/fetcher'
import buildErrors from 'modules/buildErrors'

import {
  projectMilestoneStatusCreate,
  projectMilestoneStatusCreateFailure,
  projectMilestoneStatusUpdate,
  projectMilestoneStatusUpdateFailure,
  projectMilestoneStatusDelete,
  projectMilestoneStatusDeleteFailure
} from '../actions'

import {
  PROJECT_MILESTONE_STATUS_CREATE_SUBMIT,
  PROJECT_MILESTONE_STATUS_UPDATE_SUBMIT,
  PROJECT_MILESTONE_STATUS_DELETE_SUBMIT
} from '../constants'

export function * projectMilestoneStatusCreateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      'api/v3/admin/project_milestone_statuses',
      {
        method: 'POST',
        body: JSON.stringify({
          project_milestone_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(projectMilestoneStatusCreate(response))
  } catch (exception) {
    yield put(projectMilestoneStatusCreateFailure(buildErrors(exception?.json)))
  }
}

export function * watchProjectMilestoneStatusCreateSaga () {
  yield call(takeEvery, PROJECT_MILESTONE_STATUS_CREATE_SUBMIT, projectMilestoneStatusCreateSaga)
}

export function * projectMilestoneStatusUpdateSaga ({ payload }) {
  try {
    const response = yield call(
      fetcher,
      `api/v3/admin/project_milestone_statuses/${payload.id}`,
      {
        method: 'PUT',
        body: JSON.stringify({
          project_milestone_status: {
            name: payload.name,
            hex_color: payload.hexColor
          }
        })
      }
    )
    yield put(projectMilestoneStatusUpdate(response))
  } catch (exception) {
    yield put(projectMilestoneStatusUpdateFailure(buildErrors(exception?.json)))
  }
}

export function * watchProjectMilestoneStatusUpdateSaga () {
  yield call(takeEvery, PROJECT_MILESTONE_STATUS_UPDATE_SUBMIT, projectMilestoneStatusUpdateSaga)
}

export function * projectMilestoneStatusDeleteSaga ({ payload }) {
  try {
    const body = {}
    if (payload.merge_into_project_milestone_status_id) {
      body.merge_into_project_milestone_status_id = payload.merge_into_project_milestone_status_id
    }

    yield call(
      fetcher,
      `api/v3/admin/project_milestone_statuses/${payload.id}`,
      {
        method: 'DELETE',
        body: JSON.stringify(body)
      }
    )
    yield put(projectMilestoneStatusDelete(payload))
  } catch (exception) {
    yield put(projectMilestoneStatusDeleteFailure(exception.message))
  }
}

export function * watchProjectMilestoneStatusDeleteSaga () {
  yield call(takeEvery, PROJECT_MILESTONE_STATUS_DELETE_SUBMIT, projectMilestoneStatusDeleteSaga)
}
